export const siteData = {
  business: {
    name: "A.R. Elite Detailing",
    phone: "(904) 831-2184",
    phoneTel: "9048312184",
    email: "booking@arelitedetailing.com",
    location: "Jacksonville, FL",
    areas: ["Jacksonville", "Orange Park", "Middleburg", "Fleming Island", "St. Johns", "Ponte Vedra"],
    socials: {
      instagram: "https://www.instagram.com/a.r.elite_detailing/?utm_source=chatgpt.com",
      facebook: "https://www.facebook.com/profile.php?id=61551514105794",
      tiktok: "https://www.tiktok.com/@arelitedetailing?_r=1&_t=ZP-94zdCF0WieU&fbclid=IwY2xjawQxh3BleHRuA2FlbQIxMABicmlkETE3TDdxeHNaRW1rMWNaMTM5c3J0YwZhcHBfaWQQMjIyMDM5MTc4ODIwMDg5MgABHqJtBbpRNtT7ytSQXsx8Qy77Q9Ax9yUr5sUhXrd-afUugoM7sfMua-kNXGaw_aem_INCQ7Xm9UucYrTQb2QkFGA"
    }
  },
  packages: [
    {
      id: "pkg-fresh-ride",
      name: "Fresh Ride",
      tier: "Exterior Essential",
      featured: false,
      tagline: "Quick shine. Real results.",
      pricing: { sedan: "$60", truck: "$75", xl: "$90" },
      price: "From $60",
      features: ["Exterior body wash", "Tire shine", "Window cleaning", "Spray wax"],
      desc: "A professional exterior refresh that leaves your vehicle clean, shiny, and protected — fast."
    },
    {
      id: "pkg-gloss-boss",
      name: "Gloss Boss Detail",
      tier: "Interior + Exterior",
      featured: false,
      tagline: "Inside out. Top to bottom.",
      pricing: { sedan: "$150", truck: "$200", xl: "$250" },
      price: "From $150",
      features: [
        "Interior & exterior deep clean",
        "Door panel vacuum",
        "Dashboard & panel wipe-down",
        "Window cleaning (in & out)",
        "Odor freshener"
      ],
      desc: "A complete interior and exterior deep clean that resets your cabin and restores your exterior gloss."
    },
    {
      id: "pkg-elite-detail",
      name: "Elite Detail",
      tier: "Ultimate Protection",
      featured: true,
      tagline: "The complete experience.",
      pricing: { sedan: "$250", truck: "$300", xl: "$350" },
      price: "From $250",
      features: [
        "Everything in Gloss Boss + Fresh Ride",
        "Ultimate finish & protection",
        "1-year ceramic protection included",
        "Full interior deep clean",
        "Premium exterior gloss treatment"
      ],
      desc: "Our flagship package. Combines the Gloss Boss and Fresh Ride with elite-grade ceramic protection for a showroom finish that lasts."
    }
  ],
  addons: [
    { name: "Biohazard Cleanup", icon: "AlertTriangle", desc: "Safe removal of biohazardous materials." },
    { name: "Pet Hair Removal", icon: "Scissors", desc: "Deep extraction of embedded pet hair from seats and carpets." },
    { name: "Carpet Extraction", icon: "Droplet", desc: "Hot water extraction for deeply soiled carpets." },
    { name: "Paint Enhancement / Correction", icon: "Zap", desc: "Machine polish to remove swirls, scratches, and oxidation." },
    { name: "Odor Removal", icon: "Wind", desc: "Professional-grade odor elimination treatment." }
  ],
  services: [
    {
      id: "exterior",
      title: "Exterior Detailing",
      short: "Safe hand wash, decontamination, and premium sealant for a high-gloss finish.",
      desc: "A meticulous exterior wash process that prevents scratches while stripping away road grime. Finished with a premium sealant to protect your clear coat and enhance gloss.",
      ideal: "Vehicles needing a safe, thorough wash and temporary protection.",
      features: ["Two-bucket hand wash", "Iron decontamination", "Clay bar treatment", "Wheel & tire deep clean", "Premium spray sealant"],
      icon: "Sun"
    },
    {
      id: "interior",
      title: "Interior Detailing",
      short: "Complete deep cleaning, stain removal, and conditioning for a factory-fresh cabin.",
      desc: "Our interior detailing goes beyond a simple vacuum. We deep clean every crevice, extract carpets, condition leather, and sanitize surfaces to restore that new-car feel.",
      ideal: "Daily drivers, family vehicles, or prepping a car for sale.",
      features: ["Deep vacuuming", "Steam cleaning & sanitization", "Leather conditioning", "Carpet & upholstery extraction", "Glass cleaning"],
      icon: "Maximize"
    },
    {
      id: "ceramic",
      title: "Ceramic Coating",
      short: "Multi-year durable coating for extreme gloss, hydrophobics, and protection.",
      desc: "Lock in your vehicle's shine with professional-grade ceramic coatings. Offers unmatched resistance to UV rays, bird droppings, and chemical etching while making maintenance washes a breeze.",
      ideal: "New vehicles, luxury cars, and owners wanting long-term protection.",
      features: ["1-year & 5-year options", "Extreme hydrophobic properties", "Enhanced depth and gloss", "Easier maintenance", "UV protection"],
      icon: "Shield"
    },
    {
      id: "paint-correction",
      title: "Paint Correction",
      short: "Machine polishing to remove swirls, scratches, and oxidation.",
      desc: "We safely level your clear coat using advanced machine polishing techniques to permanently remove swirl marks, light scratches, and water spots, restoring deep clarity to your paint.",
      ideal: "Vehicles with swirl marks, dull paint, or before applying a ceramic coating.",
      features: ["1 or 2-step correction", "Removes 60–90% of defects", "Restores mirror finish", "Prepares surface for coatings", "Increases vehicle value"],
      icon: "Zap"
    }
  ],
  faqs: [
    { q: "What's the difference between Fresh Ride, Gloss Boss, and Elite Detail?", a: "Fresh Ride is an exterior-only service covering wash, tire shine, windows, and spray wax. Gloss Boss adds a full interior deep clean. Elite Detail combines both plus 1-year ceramic protection — it's our most complete package." },
    { q: "How much does auto detailing cost in Jacksonville?", a: "Our Fresh Ride starts at $60 for sedans. Gloss Boss Detail starts at $150. Our Elite Detail (most popular) starts at $250 for sedans, $300 for trucks/SUVs, and $350 for XL SUVs. Pricing may vary based on vehicle condition." },
    { q: "Do you service oversized or specialty vehicles?", a: "Yes — if your vehicle doesn't fit the standard size categories listed (Sedan, Truck/SUV, Van/XL SUV), contact us or request a quote and we'll help find the best option. We're happy to work with a wide range of vehicle types." },
    { q: "Do you require a deposit?", a: "A deposit may be required for new customers. We'll let you know during the booking process. This helps us reserve your appointment and ensure we have everything ready for your service." },
    { q: "What add-on services do you offer?", a: "We offer Biohazard Cleanup, Pet Hair Removal, Carpet Extraction, Paint Enhancement/Correction, and Odor Removal. Ask about pricing when you request your quote." },
    { q: "What is ceramic coating and do you offer it?", a: "Ceramic coating is a liquid polymer that chemically bonds with your paint to create long-lasting protection and gloss. We offer 1-year ceramic protection included in our Elite Detail, and a premium 5-Year Ceramic Coating as an upgrade. Ask us about it!" },
    { q: "Do you offer mobile detailing in Jacksonville?", a: "Yes! We bring our fully equipped setup directly to your home or office across Jacksonville, Orange Park, Middleburg, Fleming Island, St. Johns, Ponte Vedra, and surrounding areas." },
    { q: "How long does a detailing service take?", a: "Fresh Ride takes about 1–2 hours. Gloss Boss Detail typically runs 2–4 hours. Elite Detail can take 4–6 hours. Paint correction and ceramic coating services may take 1–2 days depending on vehicle condition." }
  ]
};